(function (angular) {
    angular.module('bizPartEngage', [
        'ng',
        'ngAnimate',
        'ngCookies',
        'ngSanitize',
        'ui.router',
        'bizPart',
        'ngMaterial',
        'ui.bootstrap',
        'ngMessages',
        'sticky',
        'multi-transclude',
        'ui.knob',
        'pascalprecht.translate',
        'SignalR',
        'BizContainer',
        'BizContainerHelper',
        '720kb.socialshare',
        'ngclipboard',
        'matchMedia',
        'oc.lazyLoad',
        'bizWelcomeGuide',
        'bizReactWrapper'
    ]);

    angular.module('bizPartEngage').constant('genericPosition', {
        TOP: 1,
        LEFT: 2,
        RIGHT: 3,
        BOTTOM: 4,
        CENTER: 5,
    });

    angular.module('bizPartEngage').provider('bizLevel', levelProvider);
    angular.module('bizPartEngage').provider('bizPortal', portalProvider);

    angular.module('bizPartEngage').provider('bizCore', coreProvider);
    angular.module('bizPartEngage').provider('bizUser', userProvider);

    angular.module('bizPartEngage').config(configFunction);
    angular.module('bizPartEngage').run(runFunction);
    angular
        .module('bizPartEngage')
        .factory('loadingInterceptor', loadingInterceptorFunction);

    configFunction.$inject = [
        '$stateProvider',
        '$urlRouterProvider',
        '$httpProvider',
        'bizCoreProvider',
        '$translateProvider',
        '$translatePartialLoaderProvider',
        '$locationProvider',
        'bizPortalProvider',
        'bizUserProvider',
        '$ocLazyLoadProvider',
    ];
    runFunction.$inject = [
        '$rootScope',
        '$http',
        '$q',
        'base.service',
        'bizUser',
        '$state',
        'core.users.service',
        'bizLevel',
        '$translate',
        'bizNotificationService',
        'SignalRFactory',
        '$transitions',
        'bizContainerSettings',
        '$location',
        '$window',
        '$translatePartialLoader',
        'core.session.service',
        'bizPortal',
        'genericPosition',
        'bizLoaderService',
        '$locale',
        'bizPushNotificationService',
        'bizJourneyService'
    ];
    loadingInterceptorFunction.$inject = ['$q'];
    userProvider.$inject = ['bizPortalProvider', '$translateProvider'];

    function coreProvider() {
        var lastUpdate = moment();

        function GetView(stateName, fallback) {
            //Adding to make sure we get a new version of the HTML every hour...
            if (moment.duration(moment().diff(lastUpdate)).asHours() > 1) {
                lastUpdate = moment();
            }

            var override = viewOverrides.GetItemByValue('State', stateName);
            var themeOverride = portalTheme.Views.GetItemByValue(
                'State',
                stateName
            );

            if (override) {
                return siteRootPath + override.ViewUrl;
            } else if (themeOverride) {
                return siteRootPath + themeOverride.ViewUrl;
            } else {
                return siteRootPath + fallback;
            }
        }

        function GetController(stateName, fallback) {
            var override = viewOverrides.GetItemByValue('State', stateName);

            if (override && override.Controller) {
                return override.Controller;
            } else {
                return fallback;
            }
        }

        function SetViewOverrides(overrides) {
            viewOverrides = overrides;
        }

        return {
            getView: GetView,
            getController: GetController,
            setViewOverrides: SetViewOverrides,
            $get: function () {
                return {
                    getViewOverrides: function () {
                        return viewOverrides;
                    },
                    getView: GetView,
                    getController: GetController,
                    setViewOverrides: SetViewOverrides,
                };
            },
        };
    }

    function userProvider(portalProvider, $translate) {
        if (userData.Token == null) userData.Token = getBizPartAuthToken();

        var LoggedInUser = userData;
        var AccessTypeRight = {
            Read: 10,
            Write: 20,
            WriteExtended: 30,
            Admin: 40,
        };

        function SetLoggedInUser(user) {
            LoggedInUser = user;
        }

        function HasWriteOrHigherAccess(accessTypeModuleKey) {
            var hasAccess = IsAdministrator();

            if (!hasAccess) {
                if (accessTypeModuleKey) {
                    hasAccess = HasModuleAccess(
                        accessTypeModuleKey,
                        AccessTypeRight.Write
                    );
                } else {
                    try {
                        for (var i = 0; i < LoggedInUser.Roles.length; i++) {
                            if (hasAccess) {
                                break;
                            }
                            if (LoggedInUser.Roles[i].AccessTypeAccesses) {
                                for (
                                    var a = 0;
                                    a <
                                    LoggedInUser.Roles[i].AccessTypeAccesses
                                        .length;
                                    a++
                                ) {
                                    if (
                                        LoggedInUser.Roles[i]
                                            .AccessTypeAccesses[a]
                                            .AccessTypeRight >=
                                            AccessTypeRight.Write &&
                                        LoggedInUser.Roles[i]
                                            .AccessTypeAccesses[a]
                                            .AccessTypeModule.AccessTypeKey !==
                                            'ENGAGEMENT_GOAL'
                                    ) {
                                        hasAccess = true;
                                        break;
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.error(e);
                        hasAccess = false;
                    }
                }
            }

            return hasAccess;
        }

        function HasModuleAccess(accessTypeModuleKey, accessTypeAccess, ignorePortalPublic) {
            if (
                (portalProvider.IsPortalPublic() && accessTypeAccess == 10 && !ignorePortalPublic) ||
                IsAdministrator()
            )
                return true;
            if (LoggedInUser.Roles) {
                try {
                    //Checking user roles...
                    for (var i = 0; i < LoggedInUser.Roles.length; i++) {
                        if (LoggedInUser.Roles[i].AccessTypeAccesses) {
                            for (
                                var a = 0;
                                a <
                                LoggedInUser.Roles[i].AccessTypeAccesses.length;
                                a++
                            ) {
                                var correctModule =
                                    LoggedInUser.Roles[i].AccessTypeAccesses[a]
                                        .AccessTypeModule.AccessTypeKey ==
                                    accessTypeModuleKey;
                                if (
                                    correctModule &&
                                    ~~LoggedInUser.Roles[i].AccessTypeAccesses[
                                        a
                                    ].AccessTypeRight >= ~~accessTypeAccess
                                )
                                    return true;
                            }
                        }
                    }
                } catch (e) {
                    console.error(e);
                    return false;
                }
            }

            if (LoggedInUser.AllUnits) {
                try {
                    //Checking user unit roles...
                    for (var i = 0; i < LoggedInUser.AllUnits.length; i++) {
                        for (
                            var r = 0;
                            r < LoggedInUser.AllUnits[i].Roles.length;
                            r++
                        ) {
                            if (
                                LoggedInUser.AllUnits[i].Roles[r]
                                    .AccessTypeAccesses
                            ) {
                                for (
                                    var a = 0;
                                    a <
                                    LoggedInUser.AllUnits[i].Roles[r]
                                        .AccessTypeAccesses.length;
                                    a++
                                ) {
                                    var correctModule =
                                        LoggedInUser.AllUnits[i].Roles[r]
                                            .AccessTypeAccesses[a]
                                            .AccessTypeModule.AccessTypeKey ==
                                        accessTypeModuleKey;
                                    if (
                                        correctModule &&
                                        ~~LoggedInUser.AllUnits[i].Roles[r]
                                            .AccessTypeAccesses[a]
                                            .AccessTypeRight >=
                                            ~~accessTypeAccess
                                    )
                                        return true;
                                }
                            }
                        }
                    }
                } catch (e) {
                    console.error(e);
                    return false;
                }
            }
            //console.warn('No access to: ', { accessTypeModuleKey: accessTypeModuleKey, accessTypeAccess: accessTypeAccess });
            return false;
        }

        function IsAdministrator() {
            const adminRoleSystemNames = ['ADMINISTRATOR', 'PortalAdmin', 'HostAdmin'];
            return LoggedInUser.Roles ? LoggedInUser.Roles.some(role => adminRoleSystemNames.includes(role.SystemName)) : false;
        }

        function IsLoggedIn() {
            return ~~LoggedInUser.Id > 0;
        }

        return {
            AccessTypeRight: AccessTypeRight,
            HasModuleAccess: HasModuleAccess,
            IsAdministrator: IsAdministrator,
            HasWriteOrHigherAccess: HasWriteOrHigherAccess,
            IsLoggedIn: IsLoggedIn,
            SetLoggedInUser: SetLoggedInUser,
            $get: function () {
                return {
                    setLoggedInUser: function (user) {
                        LoggedInUser.Initials = IsLoggedIn() ? `${user.FirstName.slice(0, 1)}${user.LastName.slice(0, 1)}` : '';
                        moment.locale(cultureCode.substring(0, 2));

                        console.log('CULTURE: ' + cultureCode);
                    },
                    getLoggedInUser: function () {
                        return LoggedInUser;
                    },
                    AccessTypeRight: AccessTypeRight,
                    HasModuleAccess: HasModuleAccess,
                    IsAdministrator: IsAdministrator,
                    HasWriteOrHigherAccess: HasWriteOrHigherAccess,
                    IsLoggedIn: IsLoggedIn,
                    SetLoggedInUser: SetLoggedInUser,
                };
            },
        };
    }

    function levelProvider() {
        var translate;
        function getExperienceTypeLabel(key) {
            switch (~~key) {
                case 1:
                    return translate('CORE.LOGIN');
                case 2:
                    return translate('CORE.LOGINXDAYSWEEK');
                case 3:
                    return translate('CORE.LOGINXDAYSMONTH');
                case 16:
                    return translate('CORE.UNIQUEPAGEVISITS');
                case 18:
                    return translate('CORE.EXPERIENCEGAINPERWEEKINUNIT');
                case 22:
                    return translate('CORE.HTML5EDUCATION');
            }
        }

        function setTranslateProvider(t) {
            translate = t;
        }

        return {
            getExperienceTypeLabel: getExperienceTypeLabel,
            setTranslateProvider: setTranslateProvider,
            $get: function () {
                return {
                    getExperienceTypeLabel: getExperienceTypeLabel,
                    setTranslateProvider: setTranslateProvider,
                };
            },
        };
    }

    function portalProvider() {
        var PublicPortal = false;

        function IsPortalPublic() {
            return PublicPortal;
        }

        function SetPublicPortal(val) {
            PublicPortal = val;
        }

        return {
            IsPortalPublic: IsPortalPublic,
            SetPublicPortal: SetPublicPortal,
            $get: function () {
                return {
                    IsPortalPublic: IsPortalPublic,
                    SetPublicPortal: SetPublicPortal,
                };
            },
        };
    }

    function configFunction(
        $stateProvider,
        $urlRouterProvider,
        $httpProvider,
        bizCoreProvider,
        $translateProvider,
        $translatePartialLoaderProvider,
        $locationProvider,
        portalProvider,
        userProvider,
        $ocLazyLoadProvider
    ) {
        $urlRouterProvider.otherwise('/');
        $locationProvider.html5Mode(true);
        //$locationProvider.hashPrefix('!');

        $ocLazyLoadProvider.config({
            modules: GetLazyLoadModules(),
        });

        $stateProvider
            .state('base', {
                templateUrl: bizCoreProvider.getView(
                    'base',
                    'FrontEnd/Views/base.html'
                ),
                controller: bizCoreProvider.getController('base', 'base'),
                controllerAs: 'vm',
            })
            .state('noaccess', {
                url: '/noaccess',
                templateUrl: bizCoreProvider.getView(
                    'noaccess',
                    'FrontEnd/Views/noaccess.html'
                ),
                controller: bizCoreProvider.getController(
                    'noaccess',
                    'base.noaccess'
                ),
                controllerAs: 'vm',
                data: {
                    isPublic: true,
                },
            })
            .state('login', {
                url: '/login',
                templateUrl: bizCoreProvider.getView(
                    'base.core.login',
                    'FrontEnd/Core/Themes/Login5050WithBgImages/Views/login.html'
                ),
                controller: 'core.login',
                controllerAs: 'vm',
                data: {
                    isPublic: true,
                    onlyLoggedOut: true,
                },
            })
            .state('logout', {
                url: '/logout',
                templateUrl: bizCoreProvider.getView(
                    'base.core.logout',
                    'FrontEnd/Core/Views/logout.html'
                ),
                controller: 'core.logout',
                controllerAs: 'vm'                
            })
            .state('activateaccount', {
                url: '/activateaccount/:guid',
                templateUrl: bizCoreProvider.getView(
                    'base.core.login',
                    'FrontEnd/Core/Themes/Login5050WithBgImages/Views/login.html'
                ),
                controller: 'core.login',
                controllerAs: 'vm',
                data: {
                    isPublic: true,
                    onlyLoggedOut: true,
                },
            })
            .state('forgotpassword', {
                url: '/forgotpassword',
                templateUrl: bizCoreProvider.getView(
                    'core.forgotpassword',
                    'FrontEnd/Core/Themes/Login5050WithBgImages/Views/forgotpassword.html'
                ),
                controller: 'core.forgotpassword',
                controllerAs: 'vm',
                data: {
                    isPublic: true,
                },
            })
            .state('changepassword', {
                url: '/forgotpassword/:guid',
                templateUrl: bizCoreProvider.getView(
                    'core.forgotpassword',
                    'FrontEnd/Core/Themes/Login5050WithBgImages/Views/forgotpassword.html'
                ),
                controller: 'core.changepassword',
                controllerAs: 'vm',
                data: {
                    isPublic: true
                }
            })
            .state('base.home', {
                url: '/',
                templateUrl: bizCoreProvider.getView(
                    'base.home',
                    'FrontEnd/Views/home.html'
                ),
                controller: bizCoreProvider.getController(
                    'base.home',
                    'base.home'
                ),
                controllerAs: 'vm',
            })
            .state('cleanbase', {
                templateUrl: bizCoreProvider.getView(
                    'cleanbase',
                    'FrontEnd/Views/cleanbase.html'
                ),
                controller: bizCoreProvider.getController('base', 'base'),
                controllerAs: 'vm',
            });

        $httpProvider.interceptors.push('loadingInterceptor');
        $httpProvider.useApplyAsync(true);

        $translatePartialLoaderProvider.addPart('_combined');
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: siteRootPath + 'FrontEnd/i18n/{part}/{lang}.json?v=' + bizPartVersion
        });

        var culture = cultureCode.substring(0, 2);

        $translateProvider.preferredLanguage(culture);
        $translateProvider.fallbackLanguage('en');

        $translateProvider.forceAsyncReload(true);
        $translateProvider.useLoaderCache(true);
        moment.locale(culture);
        $translateProvider.useSanitizeValueStrategy('sce');

        portalProvider.SetPublicPortal(IsPortalSettingTrue('IsPortalPublic'));

        $translateProvider.preferredLanguage(culture);
        $translateProvider.forceAsyncReload(true);
        $translateProvider.useLoaderCache(true);
        $translateProvider.fallbackLanguage('sv');
        $translateProvider.useSanitizeValueStrategy('sce');
    }

    function runFunction(
        $rootScope,
        $http,
        $q,
        baseService,
        bizUser,
        $state,
        userService,
        levelProvider,
        $translate,
        bizNotificationService,
        SignalRFactory,
        $transitions,
        bizContainerSettings,
        $location,
        $window,
        $translatePartialLoader,
        sessionService,
        portalProvider,
        genericPosition,
        bizLoaderService,
        $locale,
        bizPushNotificationService,
        bizJourneyService
    ) {
        var initializationDefer = $q.defer();
        $rootScope.CultureDefer = $q.defer();
        $rootScope.Initialized = initializationDefer.promise;
        $rootScope.CultureInitialized = $rootScope.CultureDefer.promise;

        $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
            $translate.refresh();
        });

        $rootScope.RequestFullPageLoader =
            bizLoaderService.RequestFullPageLoader;

        levelProvider.setTranslateProvider($translate);

        $rootScope.AuthToken = getBizPartAuthToken();
        if (typeof isTestMode === 'undefined' || !isTestMode) {
            $http.defaults.headers.common['Auth-Token'] = $rootScope.AuthToken;
        }

        $http.defaults.headers.common['PortalId'] = portalId;
        $http.defaults.headers.common['Cache-Control'] =
            'max-age=1800, private';
        $http.defaults.headers.common['Pragma'] = undefined;
        $rootScope.logo = portalSettings['logo'];
        $rootScope.poweredby = portalSettings['poweredby'];
        $rootScope.QueryParams = $location.search();
        $rootScope.menuSettings = menuSettings;
        $rootScope.genericpositions = genericPosition;
        $rootScope.maxWidth = portalSettings['maxWidth'];

        $rootScope.GetFullscreenCalc = GetFullscreenCalc;
        $rootScope.getFullscreenWidth = getFullscreenWidth;
        $rootScope.scrollWidth = GetScrollWidth;

        $rootScope.DisableMainMenuSticky = !$rootScope.menuSettings.IsSticky;
        $rootScope.Theme = portalTheme;
        $rootScope.UnitSettings = GetUnitSettings();
        $rootScope.IsInIframe = window.location !== window.parent.location;
        $rootScope.HasWebpSupport = false;
        $rootScope.PasswordRegex = new RegExp(portalSettings['PasswordRegEx']);
        $rootScope.PasswordMinLen = 8;

        function GetUnitSettings() {
            // console.log('GetUnitSettings');
            var unitcookie = getCookie('UnitSettings');
            
            if(unitcookie === null || unitcookie === '')
                return null;
            
            return JSON.parse(unitcookie);
        }

        $rootScope.GetUnitSettingsImage = function () {
            if (!$rootScope.UnitSettings) {
                return;
            }

            var image = $rootScope.UnitSettings.Image;

            var isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
            if (isDarkMode && $rootScope.UnitSettings.ImageDarkMode && $rootScope.UnitSettings.ImageDarkMode.length > 0) {
                image = $rootScope.UnitSettings.ImageDarkMode;
            }

            return image;
        }

        $rootScope.RandomBetween = function (min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        };

        $rootScope.GetPreloadedPortalSetting = function (key) {
            return portalSettings[key];
        }

        $rootScope.HasAcceptedCookieOfType = function (type) {
            if (!type) return false;

            if (typeof CustomCheckCookieConsentFn === 'function') {
                return CustomCheckCookieConsentFn(type);
            }
            else {
                return getLocalStorage('HasAcceptedCookies') === 'true';
            }
        }

        $rootScope.MiniSettings = {
            Header: {
                KeepBgClass: false,
                PreventHideOnScroll: false
            },
            Startpage: {
                DisableLoadData: false,
            },
            Login: {
                LoginAdminUrl: siteRootPath + "admin",
                ShowLogo: false,
                ShowPortalName: true,
                AlreadyVerifiedRedirectUrl: "login"
            },
            Profile: {
                ShowMenu: true,
                ShowProfileImage: true,
                ShowUserType: true,
                ShowMobile: false,
                ShowMiddleName: false,
                ShowGender: false,
                ShowCountry: false,
                ShowComment: false,
                ShowBirthdate: false,
                ShowHiddenInPublicLists: false,
                DisableFirstName: false,
                DisableLastName: false,
                DisableMiddleName: false,
                DisableEmail: false,
                ShowUnregister: true,
                ShowWelcomeLink: true,
                CustomHeaderPhrase: undefined,
                ShowCustomSettings: false,
                DisableCustomSettings: false,
                ShowMyRelatedUsers: false,
                AutoExpandRelatedUserSystemNamesOnClean: [],
                AdditionalProfileSubMenuItems: [],
                CustomGenderFilterFn: undefined,
                HideHiddenInPublicLists: false,
                GenderMandatory: false
            },
            LikeActions: {
                HideCurrentRating: false,
                ForRolesOnly: []
            },
            Register: {
                HideUserName: false,
                HideMobile: false,
                HideCompany: false,
                MobileIsMandatory: false,
                GenderIsMandatory: false,
                UnitIsMandatory: false,
                OverrideMobilePattern: undefined,
                UserSettings: undefined // { Key: string, PhraseKey: string, Type: 'checkbox' (so far)}
            },
            CompleteRegistration: {
                ShowMiddleName: false,
                MobileMandatory: false,
            },
            Logout: {
                CustomLogoutFn: undefined
            }
        };

        $rootScope.GetMiniSetting = function (module, key) {
            return $rootScope.MiniSettings[module][key];
        }

        check_webp_feature('lossy', function (feature, res) {
            //console.log(feature, res);
            if (res === false) {
                $rootScope.HasWebpSupport = false;
                hasWebpSupport = false;
            }
        });

        function getFullscreenWidth() {
            if ($(document).height() > $(window).height()) {
                return 'calc(100vw - ' + GetScrollWidth() + 'px)';
            } else {
                return '100vw';
            }
        }

        function GetFullscreenCalc() {
            if (portalSettings.maxWidth.length > 0) {
                return 'calc(-100vw / 2 + ' + portalSettings.maxWidth + ' / 2)';
            } else {
                return 'calc(-100vw / 2 + 100% / 2)';
            }
        }

        function GetScrollWidth() {
            // Got 11px when the container-page was using the setting: Content align: center, changed to left...
            // normaly 17px for windows, 0px on OS X depending on settings.
            var scrollWidth = window.innerWidth - $(document).width();

            //console.log('scrollWidth', scrollWidth);

            // This is some scaling issue?
            if (scrollWidth == 16) {
                scrollWidth = 17;
            }

            if (scrollWidth > 17 || scrollWidth < 0) scrollWidth = 17;

            return scrollWidth;
        }

        $rootScope.$on('$locationChangeSuccess', function (newValue) {
            $rootScope.QueryParams = $location.search();
            $rootScope.ExpandMainMenu = false;

            if (!$rootScope.PreventScrollTopOnce) $window.scrollTo(0, 0);

            $rootScope.PreventScrollTopOnce = false;
        });

        $q.all([baseService.GetLoggedInUser()]).then(LoadDataDone);

        function LoadDataDone(response) {
            bizUser.setLoggedInUser(response[0].data);
            $rootScope.LoggedInUser = bizUser.getLoggedInUser();
            $rootScope.LoggedInUser.CurrentCultureId = currentCultureId;
            $rootScope.LoggedInUser.CurrentCulture = cultureCode;
            $rootScope.IsLoggedIn = bizUser.IsLoggedIn();
            $rootScope.Logout = userService.Logout;
            $rootScope.HasModuleAccess = bizUser.HasModuleAccess;
            $rootScope.AccessTypeRight = bizUser.AccessTypeRight;
            $rootScope.HasWriteOrHigherAccess = bizUser.HasWriteOrHigherAccess;
            $rootScope.IsAdministrator = bizUser.IsAdministrator;
            bizContainerSettings.CurrentUserId = $rootScope.LoggedInUser.Id;
            bizContainerSettings.CurrentUserCurrency =
                $rootScope.LoggedInUser.DefaultVirtualCurrencyValue;
            $rootScope.ShowXP =
                IsPortalSettingTrue('IsLevelSystemEnabled') && bizUser.HasModuleAccess(
                    'LEVEL_SYSTEM',
                    bizUser.AccessTypeRight.Read
                );
            $rootScope.ShowCurrency = true; //for use later, when currency is actually implemented
            bizContainerSettings.CurrentUserId = $rootScope.LoggedInUser.Id;

            if (cultureCode === 'sv-SE') {
                $locale.NUMBER_FORMATS.GROUP_SEP = ' ';
            }

            initializationDefer.resolve(true);
            console.log("angularjs initialized complete")
            document.dispatchEvent(new CustomEvent("BizpartfrontendInitialized"));

            if (bizUser.IsLoggedIn()) {
                sessionService.Initialize(sessionTimeoutInSeconds);
                sessionService.Start();
                if (IsPortalSettingTrue('IsPushNotificationsEnabled')) {
                    bizPushNotificationService.Initialize();
                }                
            }

            if (portalProvider.IsPortalPublic() || bizUser.IsLoggedIn()) {
                baseService
                    .GetMenuItemsForLoggedInUser()
                    .then(function (response) {
                        $rootScope.MenuItems = response.data;
                    });
            }

            $rootScope.SendHubMessageToServer(
                'USER_NOTIFICATION',
                'SEND_UNREAD_NOTIFICATIONS'
            );

            createFallbackFavicon($rootScope.Theme.PrimaryColor, $rootScope.Theme.PrimaryTextColor);

            if (navigator.connection) {
                navigator.connection.addEventListener('change', updateConnectionStatus);
                updateConnectionStatus();
            }
        }

        $rootScope.$on('USER_UPDATED', HandleUserUpdated);

        function HandleUserUpdated() {
            if (portalProvider.IsPortalPublic() || bizUser.IsLoggedIn()) {
                baseService
                    .GetMenuItemsForLoggedInUser()
                    .then(function (response) {
                        $rootScope.MenuItems = response.data;
                        $rootScope.$broadcast('MAIN_MENU_UPDATED');
                    });
            }
        }

        // JOURNEY
        var journeysDefer = $q.defer();
        $rootScope.JourneysInitialized = journeysDefer.promise;
        if (IsPortalSettingTrue('IsJourneyEnabled') && bizUser.IsLoggedIn()) {
            bizJourneyService.GetEngageJourneys().then((response) => {
                journeysDefer.resolve('');
                $rootScope.Journeys = response.data;
            });
        } else {
            journeysDefer.resolve('');
            $rootScope.Journeys = [];
        }
        $rootScope.$on('engageobject.finished', HandleEngageObjectFinished);

        $rootScope.GetNextJourneyItem = function(firstIfAllComplete) {
            var defer = $q.defer();
            $rootScope.JourneysInitialized.then(() => {
                if ($rootScope.Journeys) {
                    var currentJourneyIsDone = false;
                    var firstObject;
                    for (var i = 0; i < $rootScope.Journeys.length; i++) {
                        if ($rootScope.Journeys[i].IsCurrentJourney || currentJourneyIsDone) {
                            var currentJourney = $rootScope.Journeys[i];
                            for (var j = 0; j < currentJourney.EngageObjects.length; j++) {
                                if (!firstObject) firstObject = currentJourney.EngageObjects[i];

                                if (currentJourney.EngageObjects[j].Status !== 3) {
                                    defer.resolve(currentJourney.EngageObjects[j]);
                                    return;
                                }
                            }
                            currentJourneyIsDone = true;
                        }
                    }
                    if (firstIfAllComplete && firstObject) {
                        defer.resolve(firstObject);
                        return;
                    }
                } 
                defer.resolve(null);                               
            });
            return defer.promise;
        };

        $rootScope.IsJourneyStarted = function () {
            var defer = $q.defer();
            $rootScope.JourneysInitialized.then(() => {
                if ($rootScope.Journeys) {
                    for (var i = 0; i < $rootScope.Journeys.length; i++) {
                        if ($rootScope.Journeys[i].IsCurrentJourney) {
                            var currentJourney = $rootScope.Journeys[i];
                            for (var j = 0; j < currentJourney.EngageObjects.length; j++) {
                                if (currentJourney.EngageObjects[j].Status === 3) {
                                    defer.resolve(true);
                                    return;
                                }
                            }
                        }
                    }
                }
                defer.resolve(false);
            });
            return defer.promise;
        }

        $rootScope.SetCurrentJourney = function (id, gotoNextObject, gotoFirstIfDone) {
            if ($rootScope.Journeys && $rootScope.Journeys.length) {
                bizJourneyService.SetCurrentJourney(id).then(() => {
                    var currentJourney;
                    for (var i = 0; i < $rootScope.Journeys.length; i++) {
                        $rootScope.Journeys[i].IsCurrentJourney = $rootScope.Journeys[i].Id === id;
                        $rootScope.$broadcast("CURRENT_JOURNEY_CHANGED", id);

                        if ($rootScope.Journeys[i].IsCurrentJourney) {
                            currentJourney = $rootScope.Journeys[i];
                        }
                    }

                    if (gotoNextObject && currentJourney) {
                        var nextObject;
                        for (var i = 0; i < currentJourney.EngageObjects.length; i++) {
                            if (!nextObject && currentJourney.EngageObjects[i].Status !== 3) {
                                nextObject = currentJourney.EngageObjects[i];
                            }
                        }

                        if (gotoFirstIfDone && !nextObject && currentJourney.EngageObjects.length > 0) {
                            nextObject = currentJourney.EngageObjects[0];
                        }

                        if (nextObject) {
                            bizJourneyService.GoToEngageItem(nextObject);
                        }
                    }
                });
            }
        }

        $rootScope.GetAllJourneysTotalProgress = function () {
            var defer = $q.defer();
            $rootScope.JourneysInitialized.then(() => {
                var objectCount = 0;
                var objectDoneCount = 0;
                if ($rootScope.Journeys) {
                    for (var i = 0; i < $rootScope.Journeys.length; i++) {                                                    
                        for (var j = 0; j < $rootScope.Journeys[i].EngageObjects.length; j++) {
                            objectCount++;
                            if ($rootScope.Journeys[i].EngageObjects[j].Status === 3) {
                                objectDoneCount++;
                            }
                        }
                    }
                }
                var p = 0;
                if (objectCount > 0) {
                    p = (objectDoneCount * 100) / objectCount;
                }
                defer.resolve(p);
            });
            return defer.promise;
        }

        function HandleEngageObjectFinished(event, args) {
            if (args.status === 3 && $rootScope.Journeys) {
                var updatedObjectType = args.objectType;
                var updatedObjectId = args.objectId;
                var updatedToStatus = args.status;
                var anyUpdated = false;
                for (var i = 0; i < $rootScope.Journeys.length; i++) {
                    var updateJourneyProgress = false;
                    var journey = $rootScope.Journeys[i];
                    if (journey.EngageObjects.length) {
                        var finishedCount = 0;
                        for (var j = 0; j < journey.EngageObjects.length; j++) {
                            var eo = journey.EngageObjects[j];
                            if (eo.Id === updatedObjectId
                                && eo.EngageObjectType === updatedObjectType
                                && eo.Status !== updatedToStatus) {
                                eo.Status = updatedToStatus;
                                updateJourneyProgress = true;
                                anyUpdated = true;
                            }
                            if (eo.Status === 3) {
                                finishedCount++;
                            }
                        }
                        if (updateJourneyProgress) {
                            journey.TotalProgress = ((finishedCount * 100) / journey.EngageObjects.length);
                        }
                    }
                }

                if (anyUpdated) {
                    $rootScope.$broadcast('JOURNEY_OBJECT_UPDATED');
                }
            }
        }


        //CONTAINER CONFIG
        bizContainerSettings.PortalCustomerName = '';
        bizContainerSettings.PortalVersion = 1;
        bizContainerSettings.PortalDefaultCulture = 1;
        bizContainerSettings.UseApiController = true;
        bizContainerSettings.UseEngageCore = true;

        if (portalSettings['GoogleAnalyticsId'] && $rootScope.HasAcceptedCookieOfType('statistics')) {

            $rootScope.GoogleAnalyticCustomTrackers = [];
            if (portalSettings['GoogleAnalyticsId'].indexOf(';') > 0) {
                var items = portalSettings['GoogleAnalyticsId'].split(';');
                $window.ga('create', items[0], 'auto');

                for (var i = 1; i < items.length; i++) {
                    $rootScope.GoogleAnalyticCustomTrackers.push({
                        Id: items[i],
                        Name: 'customTracker_' + i,
                    });
                }

                for (
                    var i = 0;
                    i < $rootScope.GoogleAnalyticCustomTrackers.length;
                    i++
                ) {
                    var id = $rootScope.GoogleAnalyticCustomTrackers[i].Id;
                    var name = $rootScope.GoogleAnalyticCustomTrackers[i].Name;
                    $window.ga('create', id, 'auto', name);
                }
            } else {
                $window.ga('create', portalSettings['GoogleAnalyticsId'], 'auto');
            }
        }        

        $transitions.onSuccess({}, function ($transition) {
            $rootScope.PreviousState = $transition.$from();
            $rootScope.CurrentState = $transition.$to();
            $rootScope.CurrentStateClass = $rootScope.CurrentState.name.replace(
                /\./g,
                '-'
            );

            if ($rootScope.HasAcceptedCookieOfType('statistics')) {
                if (portalSettings['GoogleAnalyticsId']) {
                    $window.ga('send', 'pageview', $location.path());
                }

                if ($rootScope.GoogleAnalyticCustomTrackers) {
                    for (
                        var i = 0;
                        i < $rootScope.GoogleAnalyticCustomTrackers.length;
                        i++
                    ) {
                        var name = $rootScope.GoogleAnalyticCustomTrackers[i].Name;
                        $window.ga(name + '.send', 'pageview', $location.path());
                    }
                }

                if (portalSettings['GoogleTagManagerId']) {

                    if ($rootScope.LoggedInUser && $rootScope.LoggedInUser.Id > 0 && !$rootScope.GATHasSetUserId) {
                        $window.dataLayer.push({
                            userId: $rootScope.LoggedInUser.Id
                        });
                        $rootScope.GATHasSetUserId = true;
                    }

                    $window.dataLayer.push({
                        event: 'pageView',
                        attributes: {
                            route: $location.path(),
                        },
                    });
                }
            }

            var path = window.location.pathname;
            if (bizUser.IsLoggedIn()) {
                userService.AddUserActivity(
                    path + '#/admin' + $transition.$to().url,
                    path + '#/admin' + $transition.$from().url,
                    'PAGEVISITS'
                );
            }

            if (portalSettings.maxWidth.length > 0) {
                setTimeout(function () {
                    $('#base-home').css('max-width', portalSettings.maxWidth);
                    $('#base-home').css('width', '100%');
                    $('#base-home').css('margin', 'auto');
                }, 0);
            }

            $rootScope.LastPageLoadTime = moment();

            sessionService.Refresh();
        });

        $transitions.onStart({}, function ($transition) {
            var to = $transition.$to();

            function EvaluateAccessRule(to, noAccessState = 'noaccess') {
                if (to.data && angular.isFunction(to.data.rule)) {
                    var result = to.data.rule();
                    if (!result) {
                        $transition.abort();
                        $state.go(noAccessState);
                    }
                }
            }

            if (IsPortalSettingTrue('IsPortalPublic')) {
                EvaluateAccessRule(to, 'base.home');

                return;
            }

            if (!bizUser.IsLoggedIn() && (!to.data || !to.data.isPublic)) {
                $transition.abort();
                $state.go('login');
                return;
            } else if (
                bizUser.IsLoggedIn() &&
                to.data &&
                to.data.onlyLoggedOut
            ) {
                $transition.abort();
                $state.go('base');
                return;
            }

            if (baseService.RedirectUrls && baseService.RedirectUrls[to.name]) {
                $transition.abort();
                $state.go(baseService.RedirectUrls[to.name]);
                return;
            }

            if (
                to.self.data &&
                to.self.data.translateParts &&
                to.self.data.translateParts.length
            ) {
                for (var i = 0; i < to.self.data.translateParts.length; i++) {
                    $translatePartialLoader.addPart(
                        to.self.data.translateParts[i]
                    );
                }
            }

            EvaluateAccessRule(to);
        });

        //SIGNALR NOTIFICATIONS!
        $rootScope.MsgQueue = [];

        $rootScope.$on('SHOW_CUSTOM_NOTIFICATION', function (event, message) {
            bizNotificationService.AddCustomNotification(message);
        });

        $rootScope.$on('ConnectionState.Connected', function (event, args) {
            SendMessageQueue();
        });

        $rootScope.$on('SignalR.serverMessage', function (event, args) {
            console.info(
                'Received SignalR.serverMessage with hub server name ' +
                    args.HubServerName +
                    ' and hub key ' +
                    args.HubKey
            );

            if (args.HubServerName == 'HubGeneric') {
                $rootScope.$broadcast('HUB_' + args.HubKey, args);
            } else {
                $rootScope.$broadcast('HUB_' + args.HubServerName, args);
            }
        });        

        $rootScope.$on('HUB_HubNotification', function (event, args) {
            var content = JSON.parse(args.Content);
            if (content.Key == 'CUSTOM') {
                bizNotificationService.AddCustomNotification(content.Message);
            } else {
                bizNotificationService.AddInformationNotification(
                    content.Subject,
                    content.Message
                );
            }
        });        

        $rootScope.SendHubMessageToServer = SendHubMessageToServer;
        window.addEventListener(
            'HubClientSendServerMsg',
            HubClientSendServerMessage,
            false
        );

        function SendHubMessageToServer(hubKey, content, hubServerName) {
            var serverMsg = {
                HubServerName: hubServerName || 'HubGeneric',
                HubKey: hubKey,
                Content: content,
            };

            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent('HubClientSendServerMsg', true, true, {
                d: serverMsg,
            });
            window.dispatchEvent(evt);
        }

        function HubClientSendServerMessage(data) {
            var result = data.detail.d;
            if (result) {
                $rootScope.MsgQueue.push(result);
                SendMessageQueue();
            }
        }

        function SendMessageQueue() {
            if (SignalRFactory.IsHubconnected) {
                while ($rootScope.MsgQueue.length > 0) {
                    var msg = $rootScope.MsgQueue.splice(0, 1);
                    SignalRFactory.send(JSON.stringify(msg[0]));
                }
            }
        }

        SignalRFactory.connect();
    }

    //TODO: Add so when we get 401 error we give info to user...
    function loadingInterceptorFunction($q) {
        function isUrlForTemplateCache(url) {
            var urlLC = url.toLowerCase();
            for (var i = 0; i < htmlTemplateCachePaths.length; i++) {
                if (urlLC.indexOf(htmlTemplateCachePaths[i]) >= 0) {
                    return true;
                }
            }
            return false;
        }

        return {
            request: function (request) {
                var htmlIndex = request.url.indexOf('.html');
                if (
                    htmlIndex > 0 &&
                    htmlIndex == request.url.length - 5 &&
                    isUrlForTemplateCache(request.url) == false
                ) {
                    request.url = request.url + '?v=' + bizPartVersion;
                }

                //request.headers.RequestKey = "TESTING";

                return request;
            },
            response: function (response) {
                if (
                    debugTimes.enabled == true &&
                    response.headers('Server-Timing')
                ) {
                    var regExp = /([\d]{1,})/gim;
                    var match = regExp.exec(response.headers('Server-Timing'));
                    if (match != null && match.length > 0) {
                        var totalTime = 0;
                        for (var i = 0; i < match.length; i++) {
                            totalTime += ~~match[i];
                        }

                        if (totalTime > debugTimes.threshold) {
                            console.error(
                                'Function took ' +
                                    totalTime +
                                    'ms to execute in the backend. Method: ' +
                                    response.config.url
                            );
                        }
                    }
                }

                return response || $q.when(response);
            },
            responseError: function (rejection) {
                //Send error report...
                // if(rejection.code == 500) {

                // }
                return $q.reject(rejection);
            },
        };
    }

    function OnLoad () {
        var token = getParameterByNameFromUrl('token', location.href);
        if (!token) {
            token = getBizPartAuthToken();
        }

        var prConfigs = $.Deferred();
        $.ajax({
            url: siteRootPath + 'api/frontend/GetFrontEndConfigurations',
            dataType: 'json',
            method: 'GET',
            headers: {
                'Auth-Token': token,
            },
        }).then(function (configs) {
            viewOverrides = configs.ViewOverrides;

            urlReMapper = configs.UrlReMapper;
            notificationSettings = configs.NotificationSettings;
            menuSettings = configs.MenuSettings;
            mascot = configs.Mascot;
            journeySettings = configs.JourneySettings;
            prConfigs.resolve();
        });

        var prUser = $.Deferred();

        initialUrl = getParameterByNameFromUrl('url', location.href);
        var lang = getParameterByNameFromUrl('lang', location.href);
        var queryString = '';

        if (lang) {
            queryString = '?lang=' + lang;
        }

        $.ajax({
            url: siteRootPath + 'api/User/GetLoggedInUserSession' + queryString,
            dataType: 'json',
            headers: {
                'Auth-Token': token,
            },
        }).then(
            function (userSession) {
                if (userSession.Token && userSession.Token != '') {
                    setBizPartAuthToken(userSession.Token, userSession.Id);
                }
                userData = userSession.User;
                cultureCode = userSession.CultureCode;
                currentCultureId = userSession.CultureId;
                sessionTimeoutInSeconds = userSession.SessionTimeInMinutes * 60;
                prUser.resolve();
            },
            function () {
                prUser.resolve();
            }
        );

        var prFavorites = $.Deferred();
        $.when(prUser).then(function () {
            if (IsPortalSettingTrue('IsFavoritesEnabled') && userData.Id > 0) {
                $.ajax({
                    url: siteRootPath + 'api/favorites/GetFavorites?deepload=false',
                    dataType: 'json',
                    method: 'GET',
                    headers: {
                        'Auth-Token': token,
                    },
                }).then(
                    function (favorites) {
                        favoriteObjects = favorites;
                        prFavorites.resolve();
                    },
                    function () {
                        prFavorites.resolve();
                    }
                );
            } else {
                prFavorites.resolve();
            }
        });
        

        $.when(prConfigs, prUser, prFavorites).then(function () {
            angular.bootstrap(document, ['bizPartEngage'], { strictDi: false }); //set to true to debug minification errors un-minified
        });
    };

    window.addEventListener("load", OnLoad);

})(window.angular);
